import { accessTokenCookieName } from 'config/globalVariables'
import { getCookie } from 'hooks/useCookie'
import { ApiFile } from 'types/Application'

export const downloadFile = async (
  selectedFile: ApiFile,
  onFailure: (error: string) => void
): Promise<string | null> => {
  try {
    const options = {
      headers: {
        Authorization: `Bearer ${getCookie(accessTokenCookieName)}`,
      },
    }
    const path = `${process.env.REACT_APP_API_URL}/applications/${selectedFile.applicationId}/files/${selectedFile.id}`

    const res = await fetch(path, options)

    if (res.ok) {
      const blob = await res.blob()
      const fileUrl = URL.createObjectURL(blob)

      return fileUrl
    } else {
      const data = await res.json()
      if ('message' in data) {
        onFailure(data.message ?? '')
      }
      return null
    }
  } catch (err) {
    console.log('error', err)
    return null
  }
}
